import BasePage from './BasePage';
import React from 'react';
import queryString from 'query-string';
import Page from '../components/Page';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Input, Label, Row} from 'reactstrap';
import {isEmpty, parseDate} from '../utils/Utilities';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {
    RELEASE_STATUS_CLOSED,
    RELEASE_STATUS_OPEN,
    RELEASE_STATUS_POSTPONED,
    RELEASE_STATUS_SUSPENDED,
    RELEASE_STATUS_TAKEN,
    RELEASE_VERIFICATION_STATUS_COLOR
} from 'enqc-utilities/src/utils/Global'
import userProfilePicture from '../assets/img/users/user_pp.png';
import {BsListTask, CgDanger, FiBookOpen, MdDetails, MdHistory, MdPrint} from 'react-icons/all';
import label from 'enqc-utilities/src/label/Label'
import {FiArrowDownCircle, FiArrowUpCircle} from "react-icons/fi";
import Typography from "../components/Typography";
import {getAdmin, getData} from "../utils/StorageUtil";
import MyCardImage from "../components/Card/MyCardImage";
import {QC_ADMINISTRATOR} from "../Variable";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import ReleaseVerificationFormLaneWidget from "../components/Widget/ReleaseVerificationFormLaneWidget";
import ModelModal from "../components/modal/ModelModal";
import HorizontalLine from "../components/Widget/HorizontalLine";
import InspectionDetailPage from "./InspectionDetailPage";
import ConfirmReleaseVerificationSuspendModal from "../components/modal/ConfirmReleaseVerificationSuspendModal"
import ReopenVerificationConfirmModal from "../components/modal/ReopenVerificationConfirmModal";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";

var clone = require('safe-clone-deep');

class ReleaseVerificationDetailPage extends BasePage {

    constructor(props) {
        super(props);
        let releaseVerificationIdQuery = queryString.parse(this.props.query).id
        let state = this.state
        state.releaseVerificationIdQuery = releaseVerificationIdQuery
        state.releaseVerification = {}
        state.releaseVerificationEvent = {}
        state.releaseVerificationEvents = []
        state.updateStatusModal = false
        state.voucherInfoModal = false
        state.stepNumber = 0
        state.userFilterExpand = true
        state.confirmReleaseVerificationCloseModal = false
        state.confirmReleaseVerificationCancelModal = false
        state.confirmReleaseVerificationSuspendModal = false
        state.reopenReleaseVerificationConfirmModal = false
        state.releaseVerificationHistoryModal = false
        state.continueReleaseVerificationConfirmModal = false;
        state.modelModal = false
        state.serialComponentInfoModal = false
        if (isEmpty(releaseVerificationIdQuery)) {
            this.props.history.goBack();
        }
        this.setState(state)
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchReleaseVerificationDetail()
        setTimeout(() => {
            this.setState({
                userFilterExpand: false
            })
        }, 3000)
    }

    fetchReleaseVerificationDetail = () => {
        this.get(Endpoint.API.RELEASE_VERIFICATION, {
            params: {
                id: this.state.releaseVerificationIdQuery
            }
        }, null, response => {
            if (response.code === 200) {
                let releaseVerification = response.data
                // let releaseVerificationEvent = releaseVerification.currentReleaseVerificationEvent
                this.setState({
                    releaseVerification: releaseVerification,
                    // releaseVerificationEvent:releaseVerificationEvent
                })
            }
        }, true, true)
    }

    nextPage = () => {
        let { stepNumber, releaseVerification, releaseVerificationEvent,
            nextLabel, previousLabel} = this.state

        let formLaneApplications = releaseVerification.formLaneApplications??[]

        if (stepNumber >= formLaneApplications.length - 1) {
            return;
        }
        stepNumber = stepNumber + 1;
        if (stepNumber > 0) {
            nextLabel = label.Next
            previousLabel = label.Previous
        } else {
            nextLabel = label.Next
            previousLabel = label.Cancel
        }
        this.setState({
            stepNumber: stepNumber,
            nextLabel: nextLabel,
            previousLabel: previousLabel
        })
    }

    previousPage = () => {
        let { stepNumber, nextLabel, previousLabel } = this.state
        if (stepNumber <= 0) {
            return
        }
        stepNumber = stepNumber - 1;
        if (stepNumber > 0) {
            nextLabel = label.Next
            previousLabel = label.Previous
        } else {
            nextLabel = label.Next
            previousLabel = label.Cancel
        }
        this.setState({
            stepNumber: stepNumber,
            nextLabel: nextLabel,
            previousLabel: previousLabel
        })
    }


    suspendInspection = () => {
        let { releaseVerification } = this.state
        this.get(Endpoint.API.RELEASE_VERIFICATION_SUSPEND + "/" + RELEASE_STATUS_SUSPENDED, { params: { releaseVerificationId: releaseVerification.id } }, null, (response) => {
            if (response.code === 200) {
                this.openSuccessDialog(label.Success, label.SuccessUpdatingStatus, () => {
                    this.props.history.goBack()
                })
            } else {
                this.openFailedDialog(label.FailedUpdatingStatus, response.message, () => { })
            }
        }, true, false)
    }
    reopenInspection = () => {
        let { releaseVerification } = this.state

        this.get(Endpoint.API.RELEASE_VERIFICATION_REOPEN + "/" + RELEASE_STATUS_OPEN, { params: { releaseVerificationId: releaseVerification.id } }, null, (response) => {
            if (response.code === 200) {
                this.openSuccessDialog(label.Success, label.SuccessUpdatingStatus, () => {
                    this.props.history.goBack()
                })
            } else {
                this.openFailedDialog(label.FailedUpdatingStatus, response.message, () => { })
            }
        }, true, false)
    }


    closeReleaseVerification = () => {
        let { releaseVerification} = this.state
        let authorization = getData(Global.AUTHORIZATION)
        let admin = getAdmin()

        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT + "/" + RELEASE_STATUS_CLOSED, clone(releaseVerification), null, (response) => {
            if (response.code === 200) {
                this.openSuccessDialog(label.Success, label.SuccessUpdatingStatus, () => { })
                releaseVerification = response.data
                this.setState({releaseVerification}, () => {
                    setTimeout(() => {
                        window.open(Endpoint.API.RELEASE_VERIFICATION_PDF_REPORT+"/external?reference="+releaseVerification.reference+"&identifier="+admin.adminCode+"&platform="+QC_ADMINISTRATOR, "_blank", undefined, false)
                    }, 2000)
                })
            } else {
                this.openFailedDialog(label.FailedUpdatingStatus, response.message, () => { })
            }
        }, true, false)
    }

    cancelReleaseVerification = () => {
        let { releaseVerification } = this.state
        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT + "/" + RELEASE_STATUS_POSTPONED, clone(releaseVerification), null, (response) => {
            if (response.code === 200) {
                releaseVerification = response.data
                this.setState({
                    releaseVerification
                },() => {
                    this.openSuccessDialog(label.Success, label.SuccessUpdatingStatus, () => {
                        this.props.history.goBack()
                    })
                })
            } else {
                this.openFailedDialog(label.FailedUpdatingStatus, response.message, () => { })
            }
        }, true, false)
    }

    updateReleaseVerification = (releaseVerification) => {
        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT + "/" + RELEASE_STATUS_TAKEN, clone(releaseVerification), null, response => {
            if (response.code === 200) {
                releaseVerification = response.data;
                this.successToast(response.message)
                this.props.history.push('/releaseVerification/formCheck/' + releaseVerification.reference)
            } else {
                this.errorToast(response.message)
            }
        }, true, true)
    }


    render() {
        
        let { confirmReleaseVerificationCloseModal, confirmReleaseVerificationCancelModal,
            releaseVerificationHistoryModal, continueReleaseVerificationConfirmModal, modelModal,
            releaseVerification, confirmReleaseVerificationSuspendModal, reopenReleaseVerificationConfirmModal, releaseVerificationEvents, serialComponentInfoModal, rectifierControllerSerialNumberInfoModal} = this.state

        let admin = getAdmin()
        let creator = releaseVerification.creator??{}
        let lastUser = releaseVerification.user??{}

        let inspection = releaseVerification.inspection??{}
        let {  stepNumber } = this.state
        let releaseVerificationStatus = releaseVerification.releaseVerificationStatus??{}
        let formLaneApplications = releaseVerification.formLaneApplications??[];

        let model = releaseVerification && releaseVerification.model ? releaseVerification.model : {}

        return (
            <Page
                title={label.ReleaseVerificationDetail}
                breadcrumbs={[{ name: label.ReleaseVerificationDetail, active: true }]}>
                {super.render()}
                <ConfirmReleaseVerificationSuspendModal
                    releaseVerification={releaseVerification}
                    showing={confirmReleaseVerificationSuspendModal}
                    okCallback={() => {
                        this.setState({
                            confirmReleaseVerificationSuspendModal: false
                        }, () => {
                            this.suspendInspection()
                        })
                    }}
                    cancelCallback={() => {
                        this.setState({ confirmReleaseVerificationSuspendModal: false })
                    }}
                />
                <ReopenVerificationConfirmModal
                    show={reopenReleaseVerificationConfirmModal}
                    releaseVerification={releaseVerification}
                    onClickOk={() => {
                        this.setState({
                            reopenReleaseVerificationConfirmModal: false,
                        }, () => {
                            this.reopenInspection()
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({
                            inspectionEvent: {},
                            reopenReleaseVerificationConfirmModal: false,
                        })
                    }}
                />

                {/*<ConfirmReleaseVerificationCloseModal*/}
                {/*    releaseVerification={releaseVerification}*/}
                {/*    showing={confirmReleaseVerificationCloseModal}*/}
                {/*    okCallback={() => {*/}
                {/*        this.setState({*/}
                {/*            confirmReleaseVerificationCloseModal: false*/}
                {/*        }, () => {*/}
                {/*            this.closeReleaseVerification()*/}
                {/*        })*/}
                {/*    }}*/}
                {/*    cancelCallback={() => {*/}
                {/*        this.setState({ confirmReleaseVerificationCloseModal: false })*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<ConfirmReleaseVerificationCancelModal*/}
                {/*    releaseVerification={releaseVerification}*/}
                {/*    showing={confirmReleaseVerificationCancelModal}*/}
                {/*    okCallback={(releaseVerification) => {*/}
                {/*        this.setState({*/}
                {/*            confirmReleaseVerificationCancelModal: false*/}
                {/*        }, () => {*/}
                {/*            this.cancelReleaseVerification()*/}
                {/*        })*/}
                {/*    }}*/}
                {/*    cancelCallback={() => {*/}
                {/*        this.setState({ confirmReleaseVerificationCancelModal: false })*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<ReleaseVerificationHistoryModal*/}
                {/*    showing={releaseVerificationHistoryModal} onClose={() => {*/}
                {/*        this.setState({*/}
                {/*            releaseVerificationHistoryModal: false*/}
                {/*        })*/}
                {/*    }} releaseVerification={releaseVerification} />*/}
                
                {/*<ContinueReleaseVerificationConfirmModal*/}
                {/*    show={continueReleaseVerificationConfirmModal}*/}
                {/*    releaseVerification={releaseVerification}*/}
                {/*    onClickOk={(releaseVerification) => {*/}
                {/*        this.setState({*/}
                {/*            continueReleaseVerificationConfirmModal: false,*/}
                {/*        }, () => {*/}
                {/*            this.updateReleaseVerification(releaseVerification)*/}
                {/*        })*/}
                {/*    }}*/}
                {/*    onClickCancel={() => {*/}
                {/*        this.setState({*/}
                {/*            continueReleaseVerificationConfirmModal: false,*/}
                {/*        })*/}
                {/*    }}*/}
                {/*/>*/}
                <ModelModal
                    show={modelModal}
                    model={model}
                    onClickOk={() => {
                        this.setState({ modelModal: false })
                    }} />

                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                style={{ cursor: 'pointer' }}
                                onClick={event => {
                                    this.setState({
                                        userFilterExpand: !this.state.userFilterExpand
                                    })
                                }}
                                content={(
                                    <React.Fragment>
                                        {
                                            (this.state.userFilterExpand) ? (<FiArrowUpCircle />) : ((<FiArrowDownCircle />))
                                        }&nbsp;{label.ReleaseVerificationDetail}&nbsp;({label.ClickToExpandMoreInformation})
                                    </React.Fragment>
                                )}/>
                            <CardBody>
                                <Collapse isOpen={this.state.userFilterExpand}>
                                    <Row>
                                        <Col md={5}>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <PrimaryCardHeader content={label.Performer}/>
                                                        <CardBody>
                                                            <Row>
                                                                <Col md={4}>
                                                                    <MyCardImage
                                                                        top
                                                                        src={lastUser.imageUrl??userProfilePicture}
                                                                        onError={(elm) => this.defaultImage(elm, userProfilePicture)}
                                                                        onClick={() => {
                                                                            if (lastUser.imageUrl) {
                                                                                this.openLightBoxSingleImage(lastUser.imageUrl)
                                                                            }
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col md={8}>
                                                                    <Row>
                                                                        <Col md={4}>
                                                                            {label.FirstPerformer}
                                                                        </Col>
                                                                        <Col md={8}>
                                                                            <span>
                                                                                {
                                                                                    (creator.id)&& (<a href={'/userDetail?id=' + creator.id}>{creator.fullname}</a>)
                                                                                }
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={4}>
                                                                            {label.Created}
                                                                        </Col>
                                                                        <Col md={8}>
                                                                            <span>
                                                                                {parseDate(releaseVerification.created, DD_MM_YYYY_HH_MM_SS)}
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                    <HorizontalLine/>
                                                                    <Row>
                                                                        <Col md={4}>
                                                                            {label.LastPerformer}
                                                                        </Col>
                                                                        <Col md={8}>
                                                                            <span>
                                                                                {
                                                                                    (lastUser.id)&& (<a href={'/userDetail?id=' + lastUser.id}>{lastUser.fullname}</a>)
                                                                                }
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={4}>
                                                                            {label.LastModification}
                                                                        </Col>
                                                                        <Col md={8}>
                                                                            <span>
                                                                                {parseDate(releaseVerification.updated, DD_MM_YYYY_HH_MM_SS)}
                                                                            </span>
                                                                        </Col>
                                                                    </Row>
                                                                    <HorizontalLine/>
                                                                    <Row>
                                                                        <Col md={4}>
                                                                            {label.LastStatus}
                                                                        </Col>
                                                                        <Col md={8}>
                                                                                    <span
                                                                                        style={
                                                                                            {
                                                                                                background: RELEASE_VERIFICATION_STATUS_COLOR[releaseVerificationStatus.name],
                                                                                                paddingLeft: '8px', paddingRight: '8px', paddingTop: '4px', paddingBottom: '4px', color: 'white',
                                                                                                fontWeight: 'bold', borderRadius: '8px'
                                                                                            }
                                                                                        }>
                                                                                        {releaseVerificationStatus.label}
                                                                                    </span>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col>
                                                                    <Typography style={{ textAlign: 'center', fontSize: '32px' }} type={"text-light bg-dark"}>{releaseVerification.reference}</Typography>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Typography
                                                                        block
                                                                        type="text-white bg-primary"
                                                                        style={{ textAlign: 'center', fontSize: '32px', cursor: 'pointer' }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault()
                                                                            this.setState({
                                                                                releaseVerificationHistoryModal: true
                                                                            })
                                                                        }}>
                                                                        {label.History}&nbsp;&nbsp;&nbsp;<MdHistory />
                                                                    </Typography>
                                                                </Col>
                                                                <Col>
                                                                    <Typography
                                                                        block
                                                                        type="text-white bg-success"
                                                                        style={{ textAlign: 'center', fontSize: '32px', cursor: 'pointer' }}>
                                                                        <a target="_blank" style={{color:'white', textDecorator:'none'}} href={InspectionDetailPage.ENDPOINT+"?id="+inspection.id}>{label.Inspection}&nbsp;&nbsp;&nbsp;<BsListTask /></a>
                                                                    </Typography>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={7}>
                                            <Card>
                                                <PrimaryCardHeader content={label.Model}/>
                                                <CardBody>
                                                    <Row>
                                                        <Col md={11}>
                                                            <FormGroup>
                                                                <Label for="systemType">{label.SystemType}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="systemType"
                                                                    readOnly={true}
                                                                    value={model.systemType}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={1}>
                                                            <FormGroup>
                                                                <Label>&nbsp;</Label>
                                                                <Button
                                                                    className={"form-control btn-primary"}
                                                                    onClick={() => {
                                                                        this.setState({ modelModal: true })
                                                                    }}>
                                                                    <MdDetails />
                                                                </Button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label for="description">{label.SerialCode}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="serialCode"
                                                                    readOnly={true}
                                                                    value={inspection.serialCode}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label for="customerOrderNo">{label.CustomerOrderNo}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="customerOrderNo"
                                                                    readOnly={true}
                                                                    value={inspection.customerOrderNo}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label>{label.ReleaseStatus}</Label>
                                                                <Input
                                                                    className={"release-verification-status-" + (releaseVerificationStatus.name ? releaseVerificationStatus.name.toLowerCase() : "")}
                                                                    type="text"
                                                                    name="releaseVerificationStatus"
                                                                    readOnly={true}
                                                                    value={releaseVerificationStatus.label}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label for="description">{label.ProductSKU}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="productSKU"
                                                                    readOnly={true}
                                                                    value={inspection.productSKU}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label for="customerOrderNo">{label.ProductName}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="productName"
                                                                    readOnly={true}
                                                                    value={inspection.productName}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={4}>
                                                            <FormGroup>
                                                                <Label>{label.Client}</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="client"
                                                                    readOnly={true}
                                                                    value={inspection.client}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Label for="description">{label.Description}</Label>
                                                                <Input
                                                                    type="textarea"
                                                                    name="description"
                                                                    readOnly={true}
                                                                    value={model.description}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Collapse>
                                <Row>
                                    <Col>
                                        <Card>
                                            <CardHeader>
                                                <ButtonGroup className="float-right">
                                                    <React.Fragment>
                                                        <a
                                                            target="_blank"
                                                            href={Endpoint.API.RELEASE_VERIFICATION_PDF_REPORT+"/external?reference="+releaseVerification.reference+"&identifier="+admin.adminCode+"&platform="+QC_ADMINISTRATOR}>
                                                            <Button color={"primary"}>
                                                                {label.ExternalPrint}&nbsp;<MdPrint />
                                                            </Button>
                                                        </a>
                                                        &nbsp;
                                                        <a
                                                            target="_blank"
                                                            href={Endpoint.API.RELEASE_VERIFICATION_PDF_REPORT+"/internal?reference="+releaseVerification.reference+"&identifier="+admin.adminCode+"&platform="+QC_ADMINISTRATOR}>
                                                            <Button color={"purple"}>
                                                                {label.InternalPrint}&nbsp;<MdPrint />
                                                            </Button>
                                                        </a>
                                                        &nbsp;
                                                    </React.Fragment>
                                                    {
                                                        (releaseVerification.canSuspend) && (
                                                            <>
                                                                <Button
                                                                    style={{ marginRight: '6px' }}
                                                                    color={"danger"}
                                                                    onClick={() => {
                                                                        this.setState({ confirmReleaseVerificationSuspendModal: true })
                                                                    }}>
                                                                    {label.SuspendRelease}&nbsp;<CgDanger />
                                                                </Button>
                                                                &nbsp;
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        (releaseVerification.canReopen) && (
                                                            <>
                                                                <Button
                                                                    style={{ marginRight: '6px' }}
                                                                    color={"primary"}
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            reopenReleaseVerificationConfirmModal: true
                                                                        })
                                                                    }}
                                                                >
                                                                    {label.Reopen}&nbsp;<FiBookOpen />
                                                                </Button>
                                                                &nbsp;
                                                            </>
                                                        )
                                                    }

                                                </ButtonGroup>

                                                <Button
                                                    style={{ marginRight: '6px' }}
                                                    color={stepNumber == 0 ? "disabled" : "warning"}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.previousPage()
                                                    }}>
                                                    {label.PagePrevious}
                                                </Button>
                                                <Button
                                                    color={stepNumber >= formLaneApplications.length - 1 ? "disabled" : "primary"}
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        this.nextPage()
                                                    }}>
                                                    {label.PageNext}
                                                </Button>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <ReleaseVerificationFormLaneWidget
                                                            releaseVerification={releaseVerification}
                                                            stepFormLaneId={formLaneApplications[stepNumber] ? formLaneApplications[stepNumber].laneId : 0}
                                                            formLaneApplication={formLaneApplications[stepNumber] ? formLaneApplications[stepNumber] : {}} />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Page>
        );
    }
}

export default Object.assign(ReleaseVerificationDetailPage, { ENDPOINT: "/releaseVerification/detail" })